module.exports = __webpack_public_path__ + "img/sustainappbility.0ac83be2.png";